exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".placeListItem{display:block;text-align:center;margin-left:14px !important;margin-right:14px !important;margin-top:12px !important;border-radius:20px !important}.placeListItemHead{font-size:14px;font-weight:bold;color:#333}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/components/Placebar/components/PlacebarMenuItems/style.scss
// module id = 6229
// module chunks = 0